import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'legrandav-button-primary',
  styleUrl: 'legrandav-button-primary.css',
  shadow: true,
})
export class LegrandavButtonPrimary {
  @Prop() buttonText: string;
  @Prop() buttonOnCLick: Function;

  render() {
    return (
      <Host>
        <button>{this.buttonText}</button>
      </Host>
    );
  }
}
